import type { IListResponseType } from '@/types/api-types/IApiResponse'

export default class ListResponse {
  value: any[]

  size: number

  limit: number

  offset: number

  constructor(list: IListResponseType) {
    this.value = list.value
    this.size = list.size
    this.limit = list.limit
    this.offset = list.offset
  }
}
